export default "__VITE_ASSET__i7G8ZOnN__"